const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
};

const escapeSelectorValue = (value) => {
  if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
  return String(value).replace(/["\\]/g, '\\$&');
};

document.addEventListener('DOMContentLoaded', () => {
    hydrateWishlistFromUrl();
  	initButtons();
  	initGrid();
    updateWishlistShareLinks();
});

document.addEventListener('click', (event) => {
  const nativeShareButton = event.target.closest('[data-wishlist-native-share]');
  if (nativeShareButton) {
    event.preventDefault();
    shareWishlist();
    return;
  }

  const copyButton = event.target.closest('[data-wishlist-copy]');
  if (copyButton) {
    event.preventDefault();
    copyWishlistLink(copyButton);
    return;
  }

  const button = event.target.closest(selectors.button);
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productHandle = button.dataset.productHandle || false;
  if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');

  updateWishlist(productHandle);
  document.querySelectorAll(`${selectors.button}[data-product-handle="${escapeSelectorValue(productHandle)}"]`).forEach((matchingButton) => {
    setButtonState(matchingButton, wishlistContains(productHandle));
  });
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
  updateWishlistShareLinks();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
   return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard ? productCard.outerHTML : '';
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));  
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join(' ');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    setButtonState(button, wishlistContains(productHandle));

    if (button.dataset.wishlistBound === 'true') return;
    button.dataset.wishlistBound = 'true';
  });
};

const setButtonState = (button, active) => {
  button.classList.toggle(BUTTON_ACTIVE_CLASS, active);
  button.setAttribute('aria-pressed', active ? 'true' : 'false');
  button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');

  const activeText = button.dataset.activeText || 'Added to Wishlist';
  const defaultText = button.dataset.defaultText || 'Add to Wishlist';
  if (!button.dataset.defaultText) button.dataset.defaultText = (button.textContent || defaultText).trim() || defaultText;

  const inlineWishlistText = button.querySelector('.product-wishlist-inline__text');
  if (inlineWishlistText) {
    inlineWishlistText.textContent = active ? activeText : 'Wishlist';
    return;
  }

  if (!button.classList.contains('collection-card-wishlist-icon') && !button.querySelector('svg') && button.textContent.trim()) {
    button.textContent = active ? activeText : button.dataset.defaultText;
  }
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];  
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const uniqueWishlist = Array.from(new Set(array.filter(Boolean)));
  const wishlist = uniqueWishlist.join(LOCAL_STORAGE_DELIMITER);
  if (uniqueWishlist.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: uniqueWishlist }
  });
  updateWishlistCount();    
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const updateWishlistCount = () => {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-js-wishlist-count]').forEach((el) => {
      el.setAttribute('data-js-wishlist-count', wishlist.length);
      el.textContent = wishlist.length;
    });

    document.querySelectorAll('.wish-info').forEach((el) => {
      el.style.display = wishlist.length === 0 ? 'block' : 'none';
    });
};

const getWishlistShareUrl = () => {
  const wishlist = getWishlist();
  const url = new URL('/pages/wishlist', window.location.origin);
  if (wishlist.length) url.hash = `w=${wishlist.map(encodeURIComponent).join(LOCAL_STORAGE_DELIMITER)}`;
  return url.toString();
};

const updateWishlistShareLinks = () => {
  const shareUrl = getWishlistShareUrl();
  const subject = encodeURIComponent('My Seven Realms wishlist');
  const body = encodeURIComponent(`Here is my wishlist: ${shareUrl}`);

  document.querySelectorAll('[data-wishlist-share-url]').forEach((el) => {
    if ('value' in el) el.value = shareUrl;
    else el.textContent = shareUrl;
  });

  document.querySelectorAll('[data-wishlist-share-status]').forEach((el) => {
    el.textContent = getWishlist().length ? 'Share link ready' : 'Add products to build a shareable wishlist';
  });

  document.querySelectorAll('[data-wishlist-share-link]').forEach((link) => {
    const platform = link.dataset.sharePlatform || 'email';
    if (platform === 'email') link.href = `mailto:?subject=${subject}&body=${body}`;
    if (platform === 'facebook') link.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    if (platform === 'x') link.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${subject}`;
  });
};

const hydrateWishlistFromUrl = () => {
  const hashValue = window.location.hash && window.location.hash.indexOf('#w=') === 0
    ? window.location.hash.replace('#w=', '')
    : '';
  const wishlistParam = hashValue || new URLSearchParams(window.location.search).get('w') || new URLSearchParams(window.location.search).get('wishlist');
  if (!wishlistParam) return;
  setWishlist(wishlistParam.split(LOCAL_STORAGE_DELIMITER).map((item) => decodeURIComponent(item).trim()).filter(Boolean));
};

const copyWishlistLink = async (button) => {
  const shareUrl = getWishlistShareUrl();
  try {
    await navigator.clipboard.writeText(shareUrl);
    const originalText = button.textContent;
    button.textContent = 'Copied';
    window.setTimeout(() => { button.textContent = originalText || 'Copy Link'; }, 1600);
  } catch (error) {
    window.prompt('Copy this wishlist link:', shareUrl);
  }
};

const shareWishlist = async () => {
  const shareUrl = getWishlistShareUrl();
  if (navigator.share) {
    try {
      await navigator.share({
        title: 'My Seven Realms wishlist',
        text: 'Here is my wishlist.',
        url: shareUrl
      });
      return;
    } catch (error) {
      if (error && error.name === 'AbortError') return;
    }
  }

  const fallback = document.querySelector('[data-wishlist-copy]');
  if (fallback) copyWishlistLink(fallback);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateWishlistCount);
} else {
  updateWishlistCount();
}
